
import { DocumentType } from './createDocument/DocumentType';
import { Facet } from '../models/Facet';
import { implementOperation, IOperationActionCreator } from '../store/actions/implementOperation';

export const createDocumentOperation = new Facet<{
  documentType: DocumentType;
  newDocumentKey: string;
  fileName?: string;
  templateItemKey?: string;
  targetWindow?: Window | null;
}>('createDocument');

export const createDocument: IOperationActionCreator<typeof createDocumentOperation.type> = implementOperation({
  operationTypeFacet: createDocumentOperation
});

export const createCustomDocumentOperation = new Facet<{
  newDocumentKey: string;
  extension: string;
}>('createCustomDocument');

export const createCustomDocument: IOperationActionCreator<typeof createCustomDocumentOperation.type> = implementOperation({
  operationTypeFacet: createCustomDocumentOperation
});
